import clsx from 'clsx'
import {useEffect, useState} from 'react'
import {SupportedLanguage} from '~/utils/locales'
import HubSpotFormSkeleton from './HubSpotFormSkeleton'

type HubSpotFormProps = {
  language: string
}

const formIdMap: Record<SupportedLanguage, string> = {
  // Tier 1
  en: '698bef30-667e-4a37-bbae-821db2282975',
  de: 'd3a5d701-06a8-406d-bbe1-beb33f54c423',
  es: '32e799fa-b029-487e-b951-3232f3a2e368',
  fr: '6122ded2-3793-4ac9-942d-db1101776e5a',
  it: '35ef0d78-fbe3-4045-a4f1-efdb22ac7038',
  ja: '6eb2f659-5d47-4b30-ad15-a1d783730078',
  ko: '58de026c-b53e-4017-9fd3-6ad0ddb243a7',
  'pt-BR': 'f607ad88-1b12-44ab-b2e5-b3d2432341c8',
  ru: 'b7fe1020-65eb-4172-a781-434a229c47c0',
  'zh-CN': '94ddc074-6078-471b-ba54-bf54e0e691d6',
  'zh-TW': 'e63a73e3-98c9-4f7c-99e7-5b327ca71956',
  // Tier 2
  ar: 'ee7a3004-273b-4886-abe3-aea788c85b14',
  bg: '9f2057f8-07f1-43af-ac20-294278376678',
  ca: '2ca497ae-4acc-49be-aa46-f6be6ea4bf71',
  cs: '6b4fba8d-1f05-4c38-837c-0eb3a7d085c4',
  da: '4672a563-e8a0-4059-9993-3b84f4c35c14',
  el: 'd77e7e2d-93a8-4485-922a-4b11bfc8eba2',
  fi: '7ff891da-328a-4aa5-b39a-2824ff76f0d2',
  he: '6ffe1987-dc67-47d9-8d04-782ae78e0273',
  hr: 'c0ca0234-df0c-43eb-bceb-0a32f979c36b',
  hu: 'd34d661f-d127-45c9-9a4b-6e0f107868c5',
  id: 'fbbb5ace-1cfc-4704-8059-420bd1ce377c',
  ms: '31de329d-84b8-497d-9673-4ef9bf8e034e',
  nb: 'ba7e92a5-a203-44d6-a7f2-57119f06ef9d',
  nl: 'bed70265-19ad-421c-87a5-ffa1a2d87430',
  pl: '0d1108bd-e95a-43bf-8ed2-2a9594fc9fee',
  sk: 'c281f1ee-fd2b-47a1-a913-46f0bdac9ab6',
  sv: '038546ab-c803-42d5-b40d-97462a65c660',
  th: 'b4159ada-ed07-4726-a0c4-ce513afc8c2b',
  tr: '4e196f76-742d-4853-b8c3-f57d775c45dc',
  uk: 'a42b8e30-634b-458b-9f5c-c7b1de2fa7fc'
} as const

const HubSpotForm: React.FC<HubSpotFormProps> = ({language}) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)
    const formId = language in formIdMap ? formIdMap[language as SupportedLanguage] : formIdMap.en

    const loadForm = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '145710253',
          formId: formId,
          target: '#hsform',
          cssClass: 'hsform',
          onFormReady: () => setIsLoading(false)
        })
      } else {
        console.error('HubSpot forms script not loaded.')
        setIsLoading(false)
      }
    }

    if (!window.hbspt) {
      const script = document.createElement('script')
      script.src = '//js-eu1.hsforms.net/forms/embed/v2.js'
      script.async = true
      script.onload = loadForm
      document.body.appendChild(script)
    } else {
      loadForm()
    }
  }, [language])

  return (
    <>
      <div id="hsform" className={clsx('rounded-sm p-6', isLoading && 'hidden')} />
      <HubSpotFormSkeleton isVisible={isLoading} />
    </>
  )
}

export default HubSpotForm
